module.exports = __webpack_public_path__ + "static/media/jenkins.0ee4210e.svg";